<div class="border-1 border-round border-red-300 bg-red-50 p-3 mt-2">
    <div class="flex align-items-center gap-2 text-red-700 mb-1">
        <i class="pi pi-exclamation-circle text-red-600"></i>
        <span class="font-semibold">{{ title }}</span>
    </div>
    <div class="text-sm text-red-800">
        {{ message }}
    </div>
</div>